import React, { Component } from "react";
import { connect } from "react-redux";
// import Immutable from 'immutable';
import config from "config/api";
import { Link } from "react-router-dom";
import { isLoggedIn, getCurrentUser } from "ducks/authentication";
import Grid from "@material-ui/core/Grid";
// import Typography from '@material-ui/core/Typography';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import {
  footerBackground,
  footerBackgroundColor,
  footerLinkColor,
  footerColor,
} from "helpers/colors";

const styles = (theme) => {
  return {
    root: {
      backgroundColor: footerBackgroundColor,
      background: footerBackground,
      color: footerColor,
      fontSize: "11px",
      textAlign: "center",
      minHeight: "118px",
    },
    footerWrapper: {
      maxWidth: 1280,
      margin: "0 auto",
      padding: 20,
    },
    logoWrapper: {
      display: "block",
      textAlign: "left",
      [theme.breakpoints.down("sm")]: {
        textAlign: "center",
      },
    },
    logo: {
      backgroundRepeat: "no-repeat",
      backgroundPosition: "50% 50%",
      backgroundSize: "contain",
      // backgroundColor: "#fff",
      backgroundImage: `url(${require("assets/images/" +
        process.env.REACT_APP_SITE +
        "/logo_footer.png")})`,
      width: "95px",
      height: "56px",
      display: "inline-block",
      verticalAlign: "middle",
      margin: "0 5px 0 0",
    },
    logo2: {
      backgroundRepeat: "no-repeat",
      backgroundPosition: "50% 50%",
      // backgroundColor: "   #fff",
      backgroundSize: "contain",
      backgroundImage: `url(${require("assets/images/" +
        process.env.REACT_APP_SITE +
        "/logo_alt.png")})`,
      width: "95px",
      height: "56px",
      display: "inline-block",
      verticalAlign: "middle",
      margin: "0 auto 0 0",
    },
    inline: {
      display: "inline-block",
      width: "auto",
      textAlign: "center",
      [theme.breakpoints.down("sm")]: {
        padding: "10px 5px",
      },
    },
    link: {
      textDecoration: "none",
      color: "#fff",
      // border: "1px " + footerLinkColor + " solid",
      padding: "0 10px",
      transition: theme.transitions.create("background-color", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),

      "&:hover": {
        backgroundColor: "#fff",
        textDecoration: "underline",
      },
    },
    linkSmall: {
      margin: "0 5px",
      textDecoration: "underline",
      color: footerLinkColor,
      "&:hover": {
        textDecoration: "underline",
      },
    },
  };
};
class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}
  _openLink(e, link) {
    e.preventDefault();
    const conf = window.confirm(
      ""
    );
    if (conf) window.open(link);
  }
  render() {
    const { $$user, classes, footerVariant } = this.props;

    const $$menu = config.getMenu($$user, { asImmutable: true });
    // console.log({ footerVariant });
    return (
      <div className={classes.root}>
        <div className={classes.footerWrapper}>
          <Grid
            container
            spacing={0}
            alignItems="center"
            justify="space-around"
          >
            <Grid item xs={12} md={footerVariant !== "nologo" ? true : false}>
              <If condition={footerVariant !== "nologo"}>
                <div className={classes.logoWrapper}>
                  <div className={classes.logo} alt="logo" />
                  <div className={classes.logo2} alt="logo2" />
                </div>
              </If>
            </Grid>
            <Grid item xs={12} md={footerVariant !== "nologo" ? 7 : 10}>
              <List>
                {$$menu
                  .map((m, mIdx) => {
                    return (
                      <ListItem key={"fmn_" + mIdx} className={classes.inline}>
                        <ListItemText>
                          <Link className={classes.link} to={m.get("url")}>
                            {m.get("title")}
                          </Link>
                        </ListItemText>
                      </ListItem>
                    );
                  })
                  .toArray()}
                <span className={classes.inline}>
                  <ListItem className={classes.inline}>
                    <ListItemText>
                      <Link className={classes.link} to={"/confidentiality"}>
                        Données personnelles
                      </Link>
                    </ListItemText>
                  </ListItem>
                  <ListItem className={classes.inline}>
                    <ListItemText>
                      <Link className={classes.link} to={"/legal"}>
                        Conditions Générales
                      </Link>
                    </ListItemText>
                  </ListItem>
                </span>
              </List>
            </Grid>
            <Grid item xs={12} md={true}>
              {"© 2020 Canal" +
                process.env.REACT_APP_SITE +
                ". All rights reserved"}
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

// export default Footer;
//
//
// export default withRouter(Header);
function mapStateToProps(state) {
  const props = {
    isLoggedIn: isLoggedIn(state),
    $$user: getCurrentUser(state),
  };
  return props;
}

export default withStyles(styles)(connect(mapStateToProps)(Footer));



// WEBPACK FOOTER //
// ./src/components/Footer.jsx